import {
  POST_TAG_DEFS_BASE,
  adsAssistantClientFetch,
  type AdsAssistantFetchResult,
} from "./adsAssistantClientHttp";
import type { AdsAssistantPostTagDefRow } from "./adsAssistantClientTypes";

export async function listAdsPostTagDefs(): Promise<
  AdsAssistantFetchResult<{ ok: true; tags: AdsAssistantPostTagDefRow[] }>
> {
  return adsAssistantClientFetch(POST_TAG_DEFS_BASE, { method: "GET" });
}

export async function createAdsPostTagDef(body: {
  slug: string;
  label: string;
  sort_order?: number;
  kind?: "archetype" | "topic";
}): Promise<AdsAssistantFetchResult<{ ok: true; tag: AdsAssistantPostTagDefRow }>> {
  return adsAssistantClientFetch(POST_TAG_DEFS_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function updateAdsPostTagDef(
  id: string,
  patch: Partial<Pick<AdsAssistantPostTagDefRow, "slug" | "label" | "sort_order" | "kind">>
): Promise<AdsAssistantFetchResult<{ ok: true; tag: AdsAssistantPostTagDefRow }>> {
  return adsAssistantClientFetch(`${POST_TAG_DEFS_BASE}?id=${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
}

export async function deleteAdsPostTagDef(id: string): Promise<AdsAssistantFetchResult<{ ok: true }>> {
  return adsAssistantClientFetch(`${POST_TAG_DEFS_BASE}?id=${encodeURIComponent(id)}`, { method: "DELETE" });
}
